import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Image,
  Text,
} from "@chakra-ui/react";

import { CloseIcon } from "@/components/icons";
import CodeIcon from "./assets/code.png";
import GoIcon from "@/assets/go.png";
import { useEffect, useMemo, useRef } from "react";
import QrBg from "./assets/qr-bg.png";
import { useUserInfo } from "@/context/UserInfo";
import { shortenAddress } from "@/utils";
import QRCodeStyling from "qr-code-styling";
import LogoL from "@/assets/logo-l.png";

const QrDrawer = ({
  orderId,
  isOpen,
  onClose,
}: {
  orderId: string | undefined;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { orgName, senderAddress } = useUserInfo();
  const qrRef = useRef<HTMLDivElement>(null);

  const qrValue = useMemo(() => {
    if (!orderId) return "";
    const url = `${process.env.REACT_APP_URL}/pay/`;
    return `${url}${orderId}`;
  }, [orderId]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!qrValue || !qrRef.current) return;

      const qrCode = new QRCodeStyling({
        width: 440,
        height: 440,
        data: qrValue,
        dotsOptions: {
          color: "#FF6B00", // 橙色主题
          type: "square", // 方形点
        },
        cornersSquareOptions: {
          color: "#000000", // 黑色角落方块
          type: "extra-rounded", // 使用 extra-rounded 来实现圆角效果
        },

        backgroundOptions: {
          color: "#FFFFFF", // 白色背景
        },
        // 可选：添加 logo
        image: LogoL,
        imageOptions: {
          crossOrigin: "anonymous",
          margin: 0,
          imageSize: 0.4,
          hideBackgroundDots: true,
        },
      });

      qrRef.current.innerHTML = "";
      qrCode.append(qrRef.current);
      const canvas = qrRef.current.querySelector("canvas");
      if (canvas) {
        canvas.style.width = "220px";
        canvas.style.height = "220px";
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [qrValue, isOpen]);

  return (
    <Drawer isOpen={isOpen} placement="bottom" onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent
        sx={{
          padding: "30px 20px",
          background: "#D1732C",
        }}
      >
        <DrawerBody
          sx={{
            padding: "0",
          }}
        >
          <CloseIcon
            onClick={onClose}
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              width: "16px",
              height: "16px",
              cursor: "pointer",
              color: "#fff",
            }}
          ></CloseIcon>

          <Flex align={"center"} justify={"center"}>
            <Text
              sx={{
                color: "#FFF",
                fontSize: "32px",
                fontWeight: 700,
                marginRight: "8px",
              }}
            >
              QR
            </Text>
            <Image
              src={CodeIcon}
              sx={{
                width: "20px",
                marginRight: "8px",
              }}
            ></Image>

            <Image
              src={GoIcon}
              sx={{
                width: "16px",
                transform: "rotate(90deg)",
              }}
            ></Image>
          </Flex>
          <Flex
            flexDir={"column"}
            align={"center"}
            sx={{
              background: "#fff",
              borderRadius: "32px",
              height: "68px",
              paddingTop: "8px",
              marginTop: "20px",
            }}
          >
            <Text
              sx={{
                color: "#333",
                fontSize: "20px",
                fontWeight: 500,
              }}
            >
              {orgName ? orgName : shortenAddress(senderAddress)}
            </Text>
          </Flex>

          <Box
            sx={{
              width: "260px",
              height: "370px",
              margin: "-20px auto 0",
              background: `url(${QrBg}) no-repeat center center`,
              backgroundSize: "cover",
              padding: "30px 15px 0",
            }}
          >
            <Flex
              ref={qrRef}
              style={{ margin: "0 auto", height: "220px", width: "220px" }}
              justify={"center"}
            />

            <Text
              sx={{
                color: "#333",
                fontSize: "14px",
                fontWeight: 700,
                marginTop: "12px",
                textAlign: "center",
              }}
            >
              Please Scan this QR code to pay
            </Text>
          </Box>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default QrDrawer;
